import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Row } from "@faire/web--source/slate/Layout";
import { Toast } from "@faire/web--source/slate/Toast/Toast";
import { Tooltip } from "@faire/web--source/slate/Tooltip";
import { PortalTooltip } from "@faire/web--source/slate/Tooltip/PortalTooltip";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import * as React from "react";
export var TooltipOrToast = function(props) {
    var viewport = useViewport();
    var showToast = function() {
        if (props.hidden) {
            return;
        }
        var renderedContents = null;
        if (props.contents !== undefined) {
            if (Array.isArray(props.contents)) {
                renderedContents = props.contents.map(function(c) {
                    return c.body;
                });
            } else {
                renderedContents = props.contents.bodies;
            }
        }
        Toast.dismiss();
        var _props_toastTimeout;
        Toast.create(/*#__PURE__*/ _jsx(Row, {
            children: /*#__PURE__*/ _jsxs(Typography, {
                color: Core.text.inverse,
                children: [
                    renderedContents,
                    " ",
                    props.action
                ]
            })
        }), {
            timeout: (_props_toastTimeout = props.toastTimeout) !== null && _props_toastTimeout !== void 0 ? _props_toastTimeout : "long"
        });
    };
    if (viewport.isMobile) {
        if (props.hidden) {
            return props.targetNode;
        }
        return /*#__PURE__*/ _jsx("div", {
            "data-test-id": "quick-add-show-toast-mobile",
            onClick: showToast,
            children: /*#__PURE__*/ _jsx("div", {
                style: {
                    pointerEvents: "none"
                },
                children: props.targetNode
            })
        });
    }
    var contents = props.contents, hidden = props.hidden, action = props.action, tooltipZIndex = props.tooltipZIndex;
    return props.usePortal ? /*#__PURE__*/ _jsx(PortalTooltip, {
        placement: "top",
        tooltipZIndex: tooltipZIndex,
        tooltip: /*#__PURE__*/ _jsx(Tooltip, {
            contents: contents,
            targetNode: /*#__PURE__*/ _jsx(_Fragment, {}),
            isOpen: !hidden,
            action: action
        }),
        "data-test-id": props["data-test-id"],
        tooltipMainAxisOffset: props.portalTooltipYOffset,
        children: props.targetNode
    }) : /*#__PURE__*/ _jsx(Tooltip, _object_spread({}, props));
};
